import { useSelector } from '@xstate/react';
import { type ActorRefFrom } from 'xstate';

import { type otaMachine } from './ota-machine';

// ─────────────────────────────────────────────────────────────────────────────

export const useIsLoadingOta = (params: Params) => {
  const { actorRef } = params;

  return useSelector(actorRef, (snapshot) => {
    return (
      snapshot.matches('waiting') ||
      snapshot.matches('fetching-update-on-launch') ||
      snapshot.matches('restarting')
    );
  });
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = {
  actorRef: ActorRefFrom<typeof otaMachine>;
};
